import React,{useState, useEffect, useRef} from 'react';
import Header from '../Header';
import Sidebar from '../Sliderbar';

const Layouts = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  const sidebarRef = useRef(null); // ✅ Create ref here

  useEffect(() => {
    const handleClickOutside = (event) => {
      // ✅ Check if click is outside sidebar
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        if (window.innerWidth < 992) {
          setCollapsed(false); // ✅ Close sidebar only on mobile
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);
  return (
    <div className="page"
    data-vertical-style="overlay"
  data-toggled={collapsed ? "icon-overlay-close" : "icon-overlay-open"}
  data-icon-overlay={collapsed ? "close" : "open"}>

<Header toggleSidebar={() => setCollapsed(!collapsed)} />
<Sidebar 
 isCollapsedFromHeader={collapsed}
 sidebarRef={sidebarRef}
  />
    
      <div className="main-content app-content">
        {children}
      </div>
    </div>
  );
};

export default Layouts;
